import moment from "moment";
import React from "react";
import InfiniteScroll from "react-infinite-scroll-component";
import DesktopBreakpoint from "../../context/desktop_breakpoint";
import PhoneBreakpoint from "../../context/phone_breakpoint";
import Tooltip from "../popovers/tooltip";

export default function GlobalSearchContent(props) {
  if (props.isSearching) {
    return (
      <div className="searchResultContainerSearch">
        <div>
          Searching <i className="fa fa-spinner fa-spin" />
        </div>
      </div>
    );
  }
  return (
    <div
      id="contentScrollableDiv"
      style={{
        height: 730,
        overflow: "auto"
      }}
    >
      <InfiniteScroll
        dataLength={props.searchResults.length} // This is important field to render the next data
        next={props.handleNext}
        hasMore={props.refetch}
        inverse //
        scrollableTarget="contentScrollableDiv"
      >
        {props.searchResults.length > 0 ? (
          props.searchResults.map((item, index) => (
            <div className="search-results">
              <ul>
                <li className="media-body">
                  <div className="d-flex">
                    <h5 className="mr-auto fullHeaderTitleForMobile">
                      {item.name && item.name.length > 30 ? (
                        <Tooltip
                          item={
                            <div>
                              <DesktopBreakpoint>
                                {`${item.name.slice(0, 30)} ...`}
                              </DesktopBreakpoint>
                              <PhoneBreakpoint>{item.name}</PhoneBreakpoint>
                            </div>
                          }
                          id={`${index}-content-name`}
                          tooltipContent={item.name}
                          className="searchedCampaignNameInDrawer"
                        />
                      ) : (
                        item.name || "N/A"
                      )}
                    </h5>
                  </div>
                  <div className=" mt-2 searchResultWrapper">
                    <div className="row">
                      <div className="col-md-3">Content Type</div>
                      <div className="col-md-3">Size</div>
                      <div className="col-md-3 ">Domain</div>
                      <div className="col-md-3">Updated</div>
                    </div>
                    <div className="row">
                      <div className="col-md-3">
                        <b>{item.type || "N/A"}</b>
                      </div>
                      <div className="col-md-3">
                        <b>
                          {" "}
                          {`${(item.size / 1048576).toFixed(2)} MB` ||
                            "N/A"}{" "}
                        </b>
                      </div>
                      <div className="col-md-3 ">
                        {" "}
                        {item.domain_name && item.domain_name.length > 7 ? (
                          <Tooltip
                            item={
                              <b>
                                <DesktopBreakpoint>
                                  {`${item.domain_name.slice(0, 7)} ...`}
                                </DesktopBreakpoint>
                                <PhoneBreakpoint>
                                  {item.domain_name}
                                </PhoneBreakpoint>
                              </b>
                            }
                            id={`${index}-campaign-domain`}
                            tooltipContent={item.domain_name}
                          />
                        ) : (
                          <b> {item.domain_name || "N/A"} </b>
                        )}
                      </div>
                      <div className="col-md-3">
                        <b>
                          {item.updated_at
                            ? moment.utc(item.updated_at).fromNow()
                            : "N/A"}
                        </b>
                      </div>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
          ))
        ) : (
          <div className="searchResultContainer">
            <div className="ml-auto mr-auto searchIconWrapper mb-3">
              <i className="fas fa-search searchIcon" />
            </div>
            <div className="searchResult-noData">
              No content{" "}
              {props.searchVal ? (
                <span>
                  found for
                  <strong> {`" ${props.searchVal} "`} </strong>
                </span>
              ) : (
                "searched yet!"
              )}{" "}
            </div>
          </div>
        )}
      </InfiniteScroll>
    </div>
  );
}
